
export default function Services() {
  const services = [
    {
      id: 1,
      title: 'Plant Nursery',
      description: 'Discover our extensive collection of premium plants, from vibrant flowers to mature trees, all carefully nurtured in our state-of-the-art greenhouse facilities.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plant%20nursery%20display%20with%20variety%20of%20healthy%20potted%20plants%20and%20flowers%20arranged%20on%20wooden%20shelves%2C%20indoor%20greenhouse%20setting%20with%20natural%20lighting%2C%20colorful%20blooming%20flowers%20and%20green%20foliage%2C%20clean%20white%20background%20with%20soft%20shadows%2C%20botanical%20garden%20aesthetic%2C%20high%20quality%20nursery%20photography&width=600&height=800&seq=service-nursery&orientation=portrait'
    },
    {
      id: 2,
      title: 'Landscape Design',
      description: 'Transform your outdoor space with our custom landscape design services. Our expert designers create stunning, sustainable gardens tailored to your vision and environment.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20landscape%20design%20tools%20and%20materials%20including%20garden%20planning%20blueprints%2C%20soil%20samples%2C%20plant%20specimens%2C%20design%20sketches%20on%20wooden%20table%2C%20natural%20lighting%2C%20clean%20organized%20workspace%2C%20botanical%20design%20aesthetic%2C%20soft%20neutral%20background%2C%20high%20quality%20professional%20photography&width=600&height=800&seq=service-landscape&orientation=portrait'
    },
    {
      id: 3,
      title: 'Garden Care',
      description: 'Keep your garden thriving year-round with our comprehensive maintenance services. From seasonal pruning to pest management, we ensure your landscape stays beautiful.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20garden%20maintenance%20equipment%20and%20tools%20including%20pruning%20shears%2C%20watering%20can%2C%20organic%20fertilizers%2C%20gardening%20gloves%20arranged%20aesthetically%2C%20clean%20white%20background%20with%20natural%20shadows%2C%20fresh%20green%20plant%20elements%2C%20high%20quality%20product%20photography%20style%2C%20organized%20display&width=600&height=800&seq=service-care&orientation=portrait'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-emerald-50/50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-5xl lg:text-6xl font-serif font-bold text-emerald-900 mb-16 leading-tight">
          Our<br />Expertise
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id}
              className="group bg-white rounded-3xl border-2 border-emerald-100 overflow-hidden hover:border-emerald-300 transition-all duration-300 hover:shadow-xl cursor-pointer"
            >
              <div className="aspect-[3/4] w-full overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-serif font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
